import {
  AccountSectionsAction,
  AccountSectionsActionTypes,
} from './account-sections.actions';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { isEmpty } from 'lodash';
import { ISectionMap } from '@account-users/account/models/Audience';

export const ACCOUNTS_SECTIONS_FEATURE_KEY = 'account-sections';

export interface AccountSectionsState {
  accountSections: ISectionMap;
  isLoadingAccountSections: boolean;
}

export const initialState: AccountSectionsState = {
  accountSections: {},
  isLoadingAccountSections: false,
};

export function accountSectionsReducer(
  state: AccountSectionsState = initialState,
  action: AccountSectionsAction,
): AccountSectionsState {
  switch (action.type) {
    case AccountSectionsActionTypes.LoadSections: {
      return {
        ...state,
        isLoadingAccountSections: true,
      };
    }

    case AccountSectionsActionTypes.LoadSectionsSuccess: {
      return {
        ...state,
        isLoadingAccountSections: false,
        accountSections: action.payload,
      };
    }
  }

  return state;
}

export const getAccountSectionsState = createFeatureSelector<
  AccountSectionsState
>(ACCOUNTS_SECTIONS_FEATURE_KEY);

export const getAccountSectionsAsArray = createSelector(
  getAccountSectionsState,
  ({ accountSections }) => {
    return !isEmpty(accountSections)
      ? Object.entries(accountSections)
          .map(([key, value]) => ({
            id: Number(key),
            ...value,
          }))
          .sort((a, b) => {
            return a.hidden === b.hidden ? 0 : a.hidden ? 1 : -1;
          })
      : [];
  },
);

export const getIsLoadingAccountSections = createSelector(
  getAccountSectionsState,
  (state) => state.isLoadingAccountSections,
);

export const getAccountSectionsTotal = createSelector(
  getAccountSectionsAsArray,
  (sectionsArray) => sectionsArray.length,
);
